import { useRouter } from "next/router";
import { Container, Col, Row } from "reactstrap";
import styles from "./styles.module.scss";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import JobCard from "@/components/JobCard";

// JOB FILTERS - UK
import sectorsUK from "@/.sourceflow/jobs-sectors.json";
import jobsTypesUK from "@/.sourceflow/jobs-job_types.json";
import baseSalaryRangeUK from "@/.sourceflow/jobs-uk_base_salary_range.json";
import workTypesUK from "@/.sourceflow/jobs-work_type.json";
import locationsUK from "@/.sourceflow/jobs-job_locations.json";

// JOB FILTERS - US
import sectorsUS from "@/.sourceflow/jobs-job_sectors.json";
import jobsTypesUS from "@/.sourceflow/jobs-job_type_us.json";
import baseSalaryRangeUS from "@/.sourceflow/jobs-us_base_salary_range.json";
import workTypesUS from "@/.sourceflow/jobs-work_type_us.json";
import useJobs from "hooks/useJobs";

export const JobsFeed = ({ className, title, subTitle, heading }) => {
    
  const totalJobs = useJobs({ limit: null });

  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <JobSearch
          options={{
            urlFilters: {
              mode: "active",
              jobCategories: [
                // UK
                sectorsUK,
                jobsTypesUK,
                baseSalaryRangeUK,
                workTypesUK,
                locationsUK,

                // US
                sectorsUS,
                jobsTypesUS,
                baseSalaryRangeUS,
                workTypesUS,
              ],
              pushToHistoryOnSearch: true,
              changeURLOnFilterChange: true,
            },
            jobsUrl: `${locale ? locale : ""}jobs`,
            jobsPerPage: 10,
            searchFilters: true,
            submitDestination: null,
            performInitialSearch: true,
            searchSubmitButton: false,
            searchInput: false,
            prefilters: {
              // Filter jobs by Country
              "7710db30-b4cf-4029-b846-e02e2f0c9b3b":
                locale === "/us/"
                  ? ["3a9d7b47-ea19-464e-8fbf-d52571b038cb"]
                  : ["73aeaf93-9fd9-4947-bfd8-4ce08ce31d01"],
            },
            searchFiltersOptions: {
              showResetSearchButton: true,
              topLevelCategoryOrder: ["Sectors", "Job Sectors", "Salary Range", "US Base Salary Range", "Region", "Job Type", "Job Type US", "Work Type", "Work Type US"],
              filterShowCount: false,
              initialFilterOpenState: false,
              exclude: {
                "7710db30-b4cf-4029-b846-e02e2f0c9b3b": true, // Country
                "269c3235-90e5-44d8-8c69-bdb0c043f331": true, // Featured Employers
              },
              categorySort: {
                Expertise: { key: "name", direction: "asc" },
                // Work Type
                "644f7ee2-9b00-463a-b1a9-4fefa1abad6d": {
                  key: "name",
                  direction: "asc",
                },
                // Work Type US
                "aafb10c9-becd-46d7-8a0b-a1e02ba59f03": {
                  key: "name",
                  direction: "asc",
                },
                // Job Type
                "90f0c208-6dd9-4e68-accd-7e637ade733f": {
                  key: "name",
                  direction: "asc",
                },
                // Sectors
                "cf3eb687-952a-43b2-8ff6-b37dadf30398": {
                  key: "name",
                  direction: "asc",
                },
                // Job Sectors
                "0c6466fd-1282-46c3-8674-1a4efcb02472": {
                  key: "name",
                  direction: "asc",
                },
                // Region
                "e6d4d874-4019-4a3e-b2bd-e4fe361731de": {
                  key: "name",
                  direction: "asc",
                },
                "US Base Salary Range": function (a, b) {
                  const matchA = a.name.match(/\$([\d,]+)(?:-\d+k)?/);
                  const matchB = b.name.match(/\$([\d,]+)(?:-\d+k)?/);
                  if (!matchA && !matchB) return a.name.localeCompare(b.name);
                  if (!matchA) return 1;
                  if (!matchB) return -1;
                  return parseInt(matchA[1].replace(/,/g, ""), 10) - parseInt(matchB[1].replace(/,/g, ""), 10);
                },
                "Salary Range": function (a, b) {
                  const matchA = a.name.match(/^£([\d,]+)/);
                  const matchB = b.name.match(/^£([\d,]+)/);
                  if (!matchA && !matchB) return a.name.localeCompare(b.name);
                  if (!matchA) return 1;
                  if (!matchB) return -1;
                  return parseInt(matchA[1].replace(/,/g, ""), 10) - parseInt(matchB[1].replace(/,/g, ""), 10);
                },
              },
            },
            searchResults: ({ results }) =>
              results?.length >= 1 ? (
                <>
                  <div className="mb-4">
                    {title && <h2 className={heading}>Jobs Found</h2>}
                    <p className="text-muted">
                      {subTitle || `Showing ${totalJobs?.length} vacancies`}
                    </p>
                  </div>
                  <Row>
                    {results.map(({ job }) => (
                      <Col xs={12} key={job.id} className="mb-4">
                        <JobCard
                          {...job}
                          post_lang={locale}
                          published_at={job.published_at * 1000}
                        />
                      </Col>
                    ))}
                  </Row>
                </>
              ) : (
                <>
                  <p>
                    Sorry, we couldn't find any jobs matching your search.
                    Please try removing some filters or searching for something
                    else.
                  </p>
                </>
              ),
          }}
        />
      </Container>
    </section>
  );
};

export default JobsFeed;
